import { css } from "lit";
// import "@fontsource/epilogue";
// import "@fontsource/inter";
// import "@fontsource/inter/300.css";
// import "@fontsource/epilogue/700.css";

export default css`
  :host {
    font-family: var(--whilecat-default-font);
  }

  * {
    font-variant-ligatures: none;
  }

  sl-button[variant="primary"]::part(base) {
    color: var(--whilecat-white);
    border-radius: var(--whilecat-border-radius);
    border: 2px solid var(--whilecat-primary);
    background: var(--whilecat-primary);
  }

  sl-button[variant="primary"]::part(base):disabled:hover,
  sl-button[variant="primary"]::part(base):disabled {
    opacity: 0.5;
    color: var(--whilecat-light-3);
    background: var(--whilecat-dark-2);
    border-color: var(--whilecat-dark-2);
  }

  sl-button[variant="primary"]::part(base):hover {
    border: 2px solid var(--whilecat-primary-light);
    background: var(--whilecat-primary-light);
  }

  sl-button[variant="neutral"]::part(base) {
    border-radius: var(--whilecat-border-radius);
    background: var(--whilecat-card-background-color);
    border: 2px solid var(--whilecat-primary);
    color: var(--whilecat-primary);
  }

  sl-button[variant="neutral"]::part(base):hover {
    border-color: var(--whilecat-primary-light);
    color: var(--whilecat-primary-light);
  }

  sl-button[variant="default"]::part(base) {
    border-radius: var(--whilecat-border-radius);
    background: var(--whilecat-card-background-color);
    border: 2px solid var(--whilecat-dark-3);
    color: var(--whilecat-light-2);
  }

  sl-button[variant="default"]::part(base):hover {
    border-color: var(--whilecat-light-2);
    color: var(--whilecat-light-3);
  }

  sl-button[variant="text"]::part(base) {
    color: var(--whilecat-primary-light-2);
  }

  sl-button[variant="text"]::part(base):hover {
    color: var(--whilecat-light-3);
  }

  sl-textarea, sl-input {
    --sl-color-primary-500: var(--whilecat-light-3);
    --sl-input-background-color-hover: var(--whilecat-dark-3);
  }

  sl-textarea::part(base),
  sl-input::part(base) {
    border-radius: var(--whilecat-border-radius);
    border: none;
    background: var(--whilecat-dark-3);
    color: var(--whilecat-light-4);
  }

  sl-input::part(password-toggle-button),
  sl-input::part(clear-button),
  sl-textarea::part(clear-button),
  sl-input::part(input)::placeholder,
  sl-textarea::part(input)::placeholder {
    color: var(--whilecat-light-2);
  }

  sl-switch {
    --height: 18px;
    --thumb-size: 16px;
  }

  sl-switch::part(control) {
    --sl-color-neutral-400: var(--whilecat-dark-1);
    --sl-color-primary-600: var(--whilecat-primary);
  }

  sl-switch::part(thumb) {
    background: var(--whilecat-white)
  }

  sl-tag[variant="success"]::part(base),
  sl-badge[variant="success"]::part(base) {
    background: var(--whilecat-success-color-3);
    color: var(--whilecat-dark-1);
  }

  sl-badge[variant="danger"]::part(base) {
    background: var(--whilecat-error-color);
  }

  sl-badge[variant="neutral"]::part(base) {
    background: var(--whilecat-light-2);
  }

  sl-alert[variant="success"]::part(base) {
    border-radius: 12px;
    border: 2px solid var(--Success, #0DA37A);
    background: linear-gradient(269deg, rgba(35, 35, 47, 0.30) 42.18%, var(--Success, rgba(13, 163, 122, 0.30)) 98.57%);
  }

  sl-alert[variant="warning"]::part(base) {
    border-radius: 12px;
    border: 2px solid var(--Warning, #EBB462);
    background: linear-gradient(269deg, rgba(35, 35, 47, 0.30) 42.18%, var(--Warning, rgba(235, 180, 98, 0.30)) 98.57%);
  }

  sl-alert[variant="danger"]::part(base) {
    border-radius: 12px;
    border: 2px solid var(--Error, #EB6862);
    background: linear-gradient(269deg, rgba(35, 35, 47, 0.30) 42.18%, var(--Error, rgba(235, 104, 98, 0.30)) 98.57%);
  }

  sl-alert[variant="primary"]::part(base),
  sl-alert[variant="neutral"]::part(base) {
    border-radius: 12px;
    border: 2px solid var(--Information, #5BB7F7);
    background: linear-gradient(269deg, rgba(35, 35, 47, 0.30) 42.18%, var(--Information, rgba(91, 183, 247, 0.30)) 98.57%);
  }

  h1, h2, h3, h4, h5 {
    align-self: stretch;
    color: var(--whilecat-white);
    font-family: var(--whilecat-default-font);
    font-style: normal;
    font-weight: 700;
    margin: 0;
  }

  h1 {
    font-size: 64px;
    line-height: 72px;
  }

  h2 {
    font-size: 32px;
    line-height: 48px;
  }

  h3 {
    font-size: 24px;
    line-height: 32px;
  }

  h4 {
    font-size: 12px;
    line-height: 16px;
  }

  h5 {
    font-size: 6px;
    line-height: 8px;
  }

  p {
    color: var(--whilecat-light-3);
    font-family: var(--whilecat-default-font);
  }

  .p3 {
    font-family: var(--whilecat-default-font);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
  }

  li {
    line-height: 32px;
  }

  sl-radio::part(control),
  sl-radio::part(control--checked) {
    color: var(--whilecat-primary);
    background-color: var(--whilecat-light-4);
    border-color: var(--whilecat-light-4);
  }

  sl-radio::part(checked-icon) {
    --font-size: 12px;
  }

  sl-radio::part(control--checked):hover {
    color: var(--whilecat-primary-light);
  }

  sl-range {
    --sl-color-primary-600: var(--whilecat-primary);
    --sl-color-primary-500: var(--whilecat-primary-light);
  }

  sl-drawer::part(panel) {
    background-color: var(--whilecat-card-background-color);
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
    width: 50vw;
  }
`;
